module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading"},"fr":{"loading":"Chargement"},"es":{"loading":"Cargando"},"pt":{"loading":"Carregando"},"ar":{"loading":"جاري التحميل"},"sv":{"loading":"Laddar"},"fi":{"loading":"Ladataan"},"ja":{"loading":"ロード中"}}')
  delete Component.options._Ctor
}
